import { Action, defaultActions } from '#/common/components/DataGrid';
import { WorkOrder } from '#/graphql/types';

export const actions: Action<WorkOrder>[] = [...defaultActions];
